import { KindergartenRoleEnum } from "@king-ict/eupisi-ui/models";
import qs from "qs";
import { Redirect, Route, useLocation } from "react-router";

import { useTypedSelector } from "../app/rootReducer";

interface Props {
  path: string;
  exact?: boolean;
  component: any;
}

export const ParentAndAdminRoute = ({
  path,
  exact,
  component: Component,
}: Props) => {
  const user = useTypedSelector((state) => state.application.user);
  const location = useLocation();
  const params = qs.parse(location.search.substring(1));
  const { applicantParentOib } = params;

  return (
    <Route
      exact={exact}
      path={path}
      render={(props) =>
        (user.roleId === KindergartenRoleEnum.Parent &&
          applicantParentOib === undefined) ||
        ((user.roleId === KindergartenRoleEnum.KindergartenDirector ||
          user.roleId === KindergartenRoleEnum.KindergartenAdmin) &&
          applicantParentOib) ? (
          <Component />
        ) : (
          <>
            {user.roleId === 0 ? <></> : <Redirect to="/page-not-available" />}
          </>
        )
      }
    />
  );
};
